t = require('views/internal/teacup-with-helpers')('power_ups_about_calendar')

module.exports = ->
  t.format 'enable-the-calendar-power-up-to-gain-access-to-the-trello-calendar-view-display-cards-with-due-dates-in-a-weekly-or-monthly-format-for-a-time-based-overview-of-cards-most-useful-for-time-sensitive-projects-and-projects-with-multiple-due-dates'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_ups_about_calendar.coffee